const state = {

}

const getters = {

}

const mutations = {

}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/project/project.js